import Logger from '../logger';

const STORAGE_KEY = 'wc.overrideURL';

const getOverridesFromStorage = () => {
    const sessionItem = sessionStorage.getItem(STORAGE_KEY);
    if (!sessionItem) {
        return;
    } else {
        return JSON.parse(sessionItem);
    }
};
const setOverridesToStorage = (config) => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(config));
};
const clearOverridesFromStorage = () => {
    sessionStorage.removeItem(STORAGE_KEY);
};

const getConfigOverride = (url = window.location.href.replace(window.location.origin, '')) => {
    const configOverride = getOverridesFromStorage();
    if (!configOverride || !configOverride.overrideURL) {
        return;
    }

    if (url.match(new RegExp(configOverride.overrideURL))) {
        Logger.log('overriding config');
        return configOverride;
    } else {
        clearOverridesFromStorage();
        return;
    }
};

const setConfigOverride = (config) => {
    if (!config || !config.overrideURL) {
        return;
    }
    setOverridesToStorage(config);
};

export { getConfigOverride, setConfigOverride };
